import React from 'react';

Star.defaultProps = {
	width: 28,
	height: 26,
	isHighlighted: false,
};

function Star({ width, height, isHighlighted }) {
	return (
		<>
			<svg
				width={width}
				height={height}
				viewBox='0 0 38 36'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
			>
				<path
					d='M17.526 1.46833C18.1141 0.137324 20.0028 0.137322 20.5909 1.46833L24.6238 10.5962C24.8699 11.1532 25.3989 11.5328 26.0054 11.5877L36.0813 12.4985C37.5574 12.632 38.1459 14.4756 37.0201 15.4396L29.4801 21.8956C29.006 22.3016 28.7969 22.9375 28.9375 23.5456L31.1544 33.1328C31.4846 34.5607 29.9514 35.6943 28.6829 34.9602L19.8976 29.8757C19.3785 29.5752 18.7384 29.5752 18.2193 29.8757L9.43396 34.9602C8.16545 35.6943 6.63232 34.5607 6.96251 33.1328L9.17938 23.5456C9.32001 22.9375 9.11088 22.3016 8.63676 21.8956L1.09682 15.4396C-0.0290418 14.4756 0.559447 12.632 2.03561 12.4985L12.1115 11.5877C12.718 11.5328 13.2469 11.1532 13.4931 10.5962L17.526 1.46833Z'
					fill={isHighlighted ? '#F7CA45' : '#C3C3C3'}
				/>
			</svg>
		</>
	);
}

export default Star;
